import { MESApiService, getMomentTz } from "@dexteel/mesf-core";
import {
  ChemistryResponse,
  ChemistryResult,
  ChemistrySample,
  SampleResponse,
} from "../../../models/lab.models";

const moment = getMomentTz();

interface GetChemistriesPayload {
  assetId: number | null;
  heatId: number | null;
  signal?: AbortSignal;
}

export const getChemistryByHeat = async (payload: GetChemistriesPayload) => {
  const sqlParameters = [
    { name: "AssetId", value: payload.assetId },
    { name: "HeatId", value: payload.heatId },
  ];

  const apiService = new MESApiService();

  const resp = await apiService.callV2(
    "[RBD].[GetChemistriesByHeatId]",
    sqlParameters,
    payload.signal,
  );

  if (!resp.ok) {
    throw new Error(resp.message);
  }

  const data = resp.data as ChemistryResponse;

  data.tables[0].rows.forEach((chemistry: ChemistryResult) => {
    chemistry.Reported = chemistry.Reported
      ? moment.utc(chemistry.Reported).toDate()
      : null;
  });

  return {
    ok: true,
    data,
  };
};

export const getChemistrySample = async (
  chemistrySampleId: number,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const resp = await apiService.callV2(
    "[RBD].[GetSampleAttributesByChemistryId]",
    [{ name: "ChemistrySampleId", value: chemistrySampleId }],
    signal,
  );

  if (!resp.ok) {
    throw new Error(resp.message);
  }

  const data = resp.data as SampleResponse;

  data.tables[0].rows.forEach((sample: ChemistrySample) => {
    sample.Reported = sample.Reported
      ? moment.utc(sample.Reported).toDate()
      : null;
  });

  return {
    ok: true,
    data,
  };
};
